import { useQuery } from "@tanstack/react-query";

// export function useAuth() {
//   const { data: user, isLoading } = useQuery({
//     queryKey: ["/api/auth/user"],
//     retry: false,
//   });

//   return {
//     user,
//     isLoading,
//     isAuthenticated: !!user,
//   };
// }

export function useAuth() {
  // For development - set to true to simulate logged-in state
  const simulateAuth = false; 
  
  const { data: user, isLoading } = useQuery({
    queryKey: ["auth-status"],
    queryFn: async () => {
      if (simulateAuth) {
        return { 
          id: 1, 
          name: "Demo User",
          role: "supplier" 
        };
      }
      return null; // Not authenticated
    },
    retry: false,
    staleTime: 0 // Always check auth status
  });

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
  };
}